import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-pop_b_a",
  "use": "icon-pop_b_a-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-pop_b_a\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 1024c283.733333 0 512-228.266667 512-512S795.733333 0 512 0 0 228.266667 0 512s228.266667 512 512 512z m-185.6-509.866667H469.333333v-170.666666c0-23.466667 19.2-42.666667 42.666667-42.666667s42.666667 19.2 42.666667 42.666667v170.666666h142.933333c10.666667 0 14.933333 12.8 8.533333 19.2l-185.6 185.6c-4.266667 4.266667-10.666667 4.266667-17.066666 0L317.866667 533.333333c-6.4-6.4-2.133333-19.2 8.533333-19.2z\" p-id=\"11862\" fill=\"#1296db\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon/pop_b_a.svg
// module id = 9DB0
// module chunks = 55